import { render, staticRenderFns } from "./TaskIntervalCard.vue?vue&type=template&id=499e821c&scoped=true"
import script from "./TaskIntervalCard.vue?vue&type=script&lang=js"
export * from "./TaskIntervalCard.vue?vue&type=script&lang=js"
import style0 from "./TaskIntervalCard.vue?vue&type=style&index=0&id=499e821c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499e821c",
  null
  
)

export default component.exports